module.exports = __webpack_public_path__ + "img/2.822fc6d6.jpg";